import { Controller, useFormContext } from 'react-hook-form'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import { CustomizationField, fieldOptions } from 'modules/expenses/hooks/useExpensesCustomization'

const FIELD_NAME = 'documentType'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  customizationFields: CustomizationField[]
  onDocumentTypeChange: (value: string) => void
}

const DocumentTypeField = ({
  isFieldMandatory,
  customizationFields,
  onDocumentTypeChange,
  isFieldReadOnly,
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <SelectField
          label={i18n.t('expenses_v2.forms.new_form.fields.document_type.label')}
          mandatory={isFieldMandatory ?? false}
          none={i18n.t('expenses_v2.forms.new_form.fields.document_type.placeholder')}
          options={fieldOptions('expense', 'document_type', customizationFields)}
          value={field.value}
          onChange={(value) => {
            field.onChange(value)
            onDocumentTypeChange(value)
          }}
          error={castError(errors?.documentType)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(DocumentTypeField, FIELD_NAME))
